import(/* webpackMode: "eager", webpackExports: ["AgenticaRefreshPageContent"] */ "/vercel/path0/src/app/agentica/page-content.tsx");
